import { ParishFactory, Parish, ParishCode, ParishName, ParishFactoryError } from '@/Domain/Localization/Parish'
import { AxiosCountyData } from '@/Infrastructure/Localization/County/Persistence/Axios'

export class AxiosParishFactory implements ParishFactory<AxiosCountyData> {
  makeParish (data: AxiosCountyData): Parish {
    try {
      return new Parish(new ParishCode(data.code), new ParishName(data.name))
    } catch (error) {
      throw new ParishFactoryError(error.message)
    }
  }
}
